import { FC } from 'react'

import './style.scss'

type TextProps = {
  className?: string,
  color?: string,
  size?: string,
  weight?: string,
  lineHeight?: string,
  align?: string,
  htmlFor?: string,
  inline?: boolean,
  component?: 'p' | 'span' | 'label',
  style?: any
}

const Text:FC<TextProps> = ({ children, className = '', color = '', size = '16', weight = 'default', lineHeight = '4', align = '', inline, component = 'p', htmlFor, style, ...rest })  => {
  const classNameStr = `text ${inline ? 'd-inline-block' : 'd-block'} ${color ? 'text-' + color : ''} ${size ? 'fz-' + size : ''} ${weight ? 'fw-' + weight : ''} ${lineHeight ? 'lh-' + lineHeight : ''} ${align ? 'text-' + align : ''} ${className}`

  return (
    <>
      {component === 'p' && <p className={classNameStr} style={style} {...rest}>{children}</p>}
      {component === 'span' && <span className={classNameStr} style={style} {...rest}>{children}</span>}
      {component === 'label' && <label htmlFor={htmlFor} className={classNameStr} style={style} {...rest}>{children}</label>}
    </>
  )
}

export { Text }